// create a function that checks if width is more than 1600px then return width 1600px and calculate height depeeting on ration
// if width is less than 1600px return width and height

import { SanityFigure } from '../../graphql-types';

const getAdjustedDimenstions = (width: number, height: number) => {
    if (width > 1600) {
        return {
            width: 1600,
            height: Math.round((1600 / width) * height),
        };
    }
    return {
        width,
        height,
    };
};

export function getDimensionsFromSanityImage(
    imageWidth: number,
    imageHeight: number,
    crop: SanityFigure['crop']
) {
    if (!crop) {
        return getAdjustedDimenstions(imageWidth, imageHeight);
    }
    const cropLeft = crop.left ?? 0;
    const cropRight = crop.right ?? 0;
    const cropTop = crop.top ?? 0;
    const cropBottom = crop.bottom ?? 0;

    const actualLeft = cropLeft * imageWidth;
    const actualRight = imageWidth - cropRight * imageWidth;
    const actualTop = cropTop * imageHeight;
    const actualBottom = imageHeight - cropBottom * imageHeight;

    const boundingBoxWidth = actualRight - actualLeft;
    const boundingBoxHeight = actualBottom - actualTop;

    return getAdjustedDimenstions(boundingBoxWidth, boundingBoxHeight);
}
